var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ul',{ref:"dropdownMenuRef",staticClass:"dropdown menu vertical",class:[_vm.placement && `dropdown--${_vm.placement}`]},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }